// extracted by mini-css-extract-plugin
export default {"form":"Login_form__vCzxM","inputIn":"Login_inputIn__wDPpl","inputUp":"Login_inputUp__ufElg"};